<template>
  <div class="col-11 none" style="display: inline-flex; align-items: center">
    <div
      class="col-1 cursors"
      style="width: 25px; flex: initial !important"
      @click="handleLoadChartOptionsColumn()"
      v-tooltip.bottom="$t('comp.cha.chart_header_options.text1')"
    >
      <em class="fa fa-bar-chart" aria-hidden="true"></em>
    </div>
    <div
      class="col-1 cursors"
      style="width: 25px; flex: initial !important"
      @click="handleLoadChartOptionsLine()"
      v-tooltip.bottom="$t('comp.cha.chart_header_options.text2')"
    >
      <em class="fa fa-line-chart" aria-hidden="true"></em>
    </div>
    <slot name="append"></slot>
  </div>
</template>

<script>
import MixinCharts from 'src/util/mixinCharts';

export default {
  name: 'chart-header-options',
  mixins: [MixinCharts],
  props: {
    chartData: {
      type: Object,
    },
    index: {
      type: Number,
      default: 0,
    },
    autoChange: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleLoadChartOptionsColumn() {
      this.chartData.type = 'column';
      this.chartData.series.forEach((serie) => {
        serie.type = 'column';
      });

      const column = this.columns(this.chartData);
      const key = this.index;
      this.$emit('handleLoadChartOptions', { chartData: column, index: key });
    },

    handleLoadChartOptionsLine() {
      this.chartData.type = 'line';
      this.chartData.series.forEach((serie) => {
        serie.type = 'line';
      });

      const line = this.lines(this.chartData, this.autoChange);
      const key = this.index;
      this.$emit('handleLoadChartOptions', { chartData: line, index: key });
    },
  },
};
</script>
